<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="12" class="px-5">
              <h1 >Ooops!</h1>
              <p class="text-lead ">Página no encontrada</p>
              <router-link :to="{name:'dashboard'}" class="font-weight-bold mt-5">Ír al inicio</router-link>
            </b-col>
          </b-row>
        </div>
      </b-container>

    </div>
  </div>
</template>

<script>

export default {
  name: 'not-found',
  created(){
    if(this.$route.fullPath.indexOf("additional_information")){
      let route = this.$route.fullPath.replace("additional_information", "additional-information")
      location.href = `/intranet${route}`;
    }
  }
};
</script>
